import { StatusBadge } from '@repo/ui/primitives/status-badge';
import { notificationEventActionPresentation } from '@/lib/notification-event-presentation.js';

export function NotificationEventActionBadge({ eventName, label, className = '' }) {
    const action = notificationEventActionPresentation(eventName);
    return (
        <StatusBadge
            variant={action.variant}
            className={`shrink-0 rounded-[var(--ds-radius-control-compact)] px-[var(--ds-space-2)] font-mono text-[10px] tracking-wide ${className}`}
        >
            {label || action.label}
        </StatusBadge>
    );
}
